import styled from "styled-components";

export const CheckoutModalBodyContainer = styled.div`
  .cost-col {
    width: 120px;
    text-align: right;
  }
`;
